import { faqData } from '@/mocks/gossipData';

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            吃瓜问答
          </h2>
          <p className="text-foreground-500 text-base">
            关于51吃瓜官网在线，你想知道的都在这里
          </p>
        </div>
        <div className="space-y-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}